// engine
import { ArGraphics, ArText, ORIENTATION } from '@aceroll/core';

// library
import { ArPopup } from '@aceroll/core/library';

const featureEnterPopupConfig = {
    label: 'feature-enter-popup',
    background: {
        label: 'feature-enter-popup-background',
        baseSize: {
            [ORIENTATION.LANDSCAPE]: {
                width: 2048,
                height: 945
            },
            [ORIENTATION.PORTRAIT]: {
                width: 945,
                height: 2048
            }
        }
    },
    content: {
        label: 'feature-enter-popup-content',
        baseSize: {
            [ORIENTATION.LANDSCAPE]: {
                width: 920,
                height: 1080
            },
            [ORIENTATION.PORTRAIT]: {
                width: 1040,
                height: 920
            },
        },
        baseAnchor: {
            [ORIENTATION.LANDSCAPE]: {
                x: 0.5,
                y: 0.5
            },
            [ORIENTATION.PORTRAIT]: {
                x: 0.5,
                y: 0.5
            }
        },
        text: {},
        spine: {
            src: 'spine-feature_enter_popup',
            animations: {
                show_landscape: 'in_l',
                idle_landscape: 'idle_l',
                show_portrait: 'in_p',
                idle_portrait: 'idle_p'
            }
        }
    },
    sounds: {
        show: 'bonus_game_triggered',
        idle: null,
        hide: 'feature_enter_popup_hide'
    },
    behaviour: {
        autoProceedTime: 30000,
        skipOnClick: true
    }
};

export class FeatureEnterPopup extends ArPopup {
    started = false;

    bgLsGraphics = new ArGraphics('feature-prompt-background-landscape');
    bgPtGraphics = new ArGraphics('feature-prompt-background-portrait');

    #animations = {
        show: null,
        idle: null
    };

    constructor() {
        super(featureEnterPopupConfig);
        this.setup();
    }

    setup() {
        super.setup();
        this.#setupBgGraphics();

        this.background.alpha = 0;
    }

    #setupBgGraphics() {
        const { background } = this.config;

        this.bgLsGraphics.rect(0, 0, background.baseSize[ORIENTATION.LANDSCAPE].width, background.baseSize[ORIENTATION.LANDSCAPE].height);
        this.bgLsGraphics.fill('#0F0715');
        this.bgLsGraphics.visible = false;

        this.bgPtGraphics.fill('#0F0715');
        this.bgPtGraphics.rect(0, 0, background.baseSize[ORIENTATION.PORTRAIT].width, background.baseSize[ORIENTATION.PORTRAIT].height);
        this.bgPtGraphics.fill();
        this.bgPtGraphics.visible = false;

        this.background.addChild(this.bgLsGraphics, this.bgPtGraphics);
    }

    #addText() {
        const titleText = ArText.from('bonus_intro_free-spins', 'featureEnterTitle', 'popup-title');
        const descriptionText = ArText.from('bonus_intro_description', 'featureEnterDescription', 'popup-description');
        const text1 = ArText.from('click_to_continue_uc', 'featureEnterSkip', 'click-to-continue-text');
        const text2 = ArText.from('click_to_continue_uc', 'featureEnterSkip', 'click-to-continue-text');

        titleText.anchor.set(0.5);
        descriptionText.anchor.set(0.5);
        text1.anchor.set(0.5);
        text2.anchor.set(0.5);


        this.contentSpine.addToSlot(titleText, 'text_holder_title');
        this.contentSpine.addToSlot(descriptionText, 'text_holder_subtitle');
        this.contentSpine.addToSlot(text1, 'text_holder_2');
        this.contentSpine.addToSlot(text2, 'text_holder_1');
    }

    async show(amount, autoProceed) {
        super.show();

        this.visible = true;

        this.#addText(amount);

        await Promise.all([
            this.background.fade(1, 300),
            this.contentSpine.setImmediately(this.#animations.show)
        ]);

        this.started = true;

        this.contentSpine.addImmediately(this.#animations.idle, true);

        return this.proceed(autoProceed);
    }

    async hide() {
        this.started = false;

        await this.content.fade(0, 500);
        await this.background.fade(0, 300);

        this.visible = false;
        this.contentSpine.stop(true);
        this.content.alpha = 1;
    }

    onLandscape() {
        this.bgPtGraphics.visible = false;
        this.bgLsGraphics.visible = true;

        const { animations } = this.config.content.spine;

        this.#animations.show = animations.show_landscape;
        this.#animations.idle = animations.idle_landscape;

        this.contentSpine.position.set(460, 540);

        if (this.started) {
            this.contentSpine.stop(true);
            this.contentSpine.setImmediately(this.#animations.idle, true);
        }
    }

    onPortrait() {
        this.bgLsGraphics.visible = false;
        this.bgPtGraphics.visible = true;

        const { animations } = this.config.content.spine;

        this.#animations.show = animations.show_portrait;
        this.#animations.idle = animations.idle_portrait;

        this.contentSpine.position.set(530, 270);

        if (this.started) {
            this.contentSpine.stop(true);
            this.contentSpine.setImmediately(this.#animations.idle, true);
        }
    }
}